export default "__VITE_ASSET__DPgBwOtg__"